import { gql } from "graphql-tag";
import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const storeFinanceBlock = gql`
  fragment storeFinanceBlock on Store_page_contentBodyStore_finance_block {
    type
    label
    primary {
      title
      description
      link {
        ...documentLink
        ...externalLink
      }
      link_name
      banner_title
      banner_description
      banner_image
      ndis_logo
    }
  }
  ${documentLink}
  ${externalLink}
`;
